import axios from 'axios'
import { getTimezoneOffset } from 'src/consumer/helpers/utilFunctions'
import { apiURL, commonHeadersWeb } from 'src/consumer/services'

export async function postMentalState(type, value, src, srcId) {
  const token = localStorage.getItem('token')
  const data = {}

  try {
    const res = await axios.post(
      `${apiURL}/api/secure/user/stat?type=${type}&value=${value}&zoneOffset=${encodeURIComponent(
        getTimezoneOffset(),
      )}&src=${src}&src-id=${srcId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          ...commonHeadersWeb,
          'ef-user-country-code': localStorage.getItem('countryCode'),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )

    return res
  } catch (err) {
    console.log(err)
    return err
  }
}
